import _ from 'underscore';
import { BaseSurvey } from '../base-survey';
import { BudgetCenterOverallSatisfactionSurveyView } from './view';
import { BudgetCenterUrl } from '../constants';

const userPrefName = 'BudgetCenterPageLastVisitDate';

export class BudgetCenterOverallSatisfactionSurvey extends BaseSurvey {
  getSurveyName = () => 'BudgetCenterOverallSatisfactionSurvey';

  getSurveyId = isTestEnv => (isTestEnv ? '43d24b1d-d6b8-46ed-8ec7-901c7cbd147b' : 'df7e1834-e2eb-4675-aff2-9d01d60ee2d0');

  validateTriggerCondition = () => {
    this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, Start`);
    const isPiloted = _.get(this.serverContext, ['DynamicPermissions', 'SpendSurveyBudgetCenterPageOverall']);
    const isVisitBudgetCenterPage = _.get(window, ['survey', 'VisitBudgetCenter']);
    const isBudgetCenterUrl = window.location.pathname.startsWith(BudgetCenterUrl);
    const lastVisitDateString = _.get(this.SurveyPreferenceService.PreferenceService.findByNameAtUserLevel(userPrefName), 'Data');

    const shouldTrigger = !!(isPiloted && isVisitBudgetCenterPage && lastVisitDateString && isBudgetCenterUrl);
    this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, shouldTrigger: ${shouldTrigger}, isPiloted: ${isPiloted}, isVisitBudgetCenterPage: ${isVisitBudgetCenterPage}, isBudgetCenterUrl: ${isBudgetCenterUrl}, lastVisitDateString: ${lastVisitDateString}`);

    window.survey.VisitBudgetCenter = false;
    return shouldTrigger;
  };

  getSurveyComponent = () => BudgetCenterOverallSatisfactionSurveyView;
}
